// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  // apiUrl: 'http://localhost:8000',
  // apiUrl: 'http://54.244.197.16:8000',
  // apiUrl: 'http://34.214.50.0:8000'
  apiUrl: 'https://api.seaker.ph',
  GOOGLE_API_KEY: 'AIzaSyCCJ839hBwp46kKaZ98MgrjL0pUi2Htt_k'
};
